import React from 'react'

const PlayIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path fill="#0D1536" fillOpacity=".65" fillRule="evenodd" d="M4.174 4.176c-.004.008-.007.02-.007.033v11.582c0 .014.003.025.007.033l10.81-5.796.006-.008c.005-.01.01-.022.01-.04l1.665-.001L15 9.98c0-.016-.004-.03-.01-.038-.002-.005-.005-.007-.006-.008M3.303 17.253c-.499-.31-.803-.864-.803-1.462V4.209c0-.597.304-1.15.801-1.46.498-.31 1.116-.332 1.633-.057l10.834 5.772c.552.294.898.878.899 1.515 0 .638-.344 1.222-.895 1.517l-10.834 5.81c-.243.13-.508.194-.772.194-.3 0-.598-.083-.863-.247z" clipRule="evenodd"/>
  </svg>
)

export default PlayIcon
